module.exports = __webpack_public_path__ + "media/application/images/icons/editor-link-43c67c156fbde4df81055505c00452a0.svg";